<div class="flex justify-center items-center gap-2">
  @if (label) {
    <span>{{ label }}</span>
  }
  @for (icon of icons; track icon) {
    <div
      [ngClass]="[bgClass || 'bg-neutral-700 group-hover/shortcut:bg-neutral-600']"
      class="w-6 h-6 text-neutral-400 group-hover/shortcut:text-neutral-300 flex justify-center items-center gap-1 rounded"
      >
      @switch (icon.type) {
        @case (IconType.ICON) {
          <flx-icon
            [name]="icon.name"
            />
        }
        @case (IconType.KEY) {
          <span
            [ngClass]="[icon.name.length > 2 ? 'text-[10px]/[16px] font-semibold' : 'text-sm']"
            class="uppercase"
            >{{ icon.name }}</span
            >
          }
        }
      </div>
    }
  </div>
